module.exports = __webpack_public_path__ + "assets/img/prize-title.63851d0e.png";